var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqifiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 21,
    viewBox: "0 0 101 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4815 20.9059V0.100586H43.7751V2.08599H33.6561V9.46212H43.586V11.4477H33.6561V18.8238H43.8689V20.9043H31.4815V20.9059Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4289 20.8981V0.0927734H74.4144V20.8981H72.4289Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7222 20.8981V0.0927734H100.708V20.8981H98.7222Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5899 18.8198H57.5885C55.5078 18.7246 53.6163 17.9686 52.1041 16.3612C50.4967 14.7538 49.7391 12.7669 49.7391 10.4973C49.7391 8.22751 50.4953 6.24197 52.1041 4.6332C53.7129 3.0245 55.603 2.17461 57.7775 2.17461C60.0471 2.17461 61.9388 3.02579 63.451 4.6332C65.0584 6.24067 65.816 8.22751 65.816 10.4973C65.816 12.7669 65.0598 14.7525 63.451 16.3612C63.1667 16.6455 62.884 16.9282 62.506 17.2125H65.4379C66.1 16.4564 66.572 15.5098 67.0453 14.5647C67.6123 13.3353 67.8013 11.917 67.8013 10.4988C67.8013 9.08029 67.517 7.75578 67.0453 6.43241C66.4781 5.20308 65.816 4.06764 64.8707 3.12257C63.9257 2.17728 62.8854 1.41854 61.6559 0.851472C60.4266 0.284328 59.1021 0 57.6837 0C56.2653 0 55.036 0.284328 53.8067 0.851472C52.5772 1.41854 51.5369 2.17591 50.5919 3.12099C49.6468 4.06628 48.9845 5.20172 48.4173 6.43105C47.8504 7.66037 47.6613 9.079 47.6613 10.4973C47.6613 11.9157 47.9456 13.2402 48.4173 14.5634C48.9845 15.7926 49.6468 16.9282 50.5919 17.8734C51.5369 18.8184 52.5772 19.5761 53.8067 20.143C55.0356 20.71 56.2644 20.9941 57.5885 20.9941V20.9944H68.5589V18.8198L57.5899 18.8198Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7565 9.45801V20.9002H82.931V11.3496H91.8207V9.45801H80.7565Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7565 7.85126H82.931V1.98729H93.1453V0.0957031H80.7565V7.85126Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0986328V20.999H15.2739L15.232 18.1728H2.82624V2.9248H20.9004V0.0986328H0Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65405 8.64314H18.1066V11.9226H5.65002V14.8172H18.1066V20.9993H20.9049V5.74854H5.65405V8.64314Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqifiLogo);
export default __webpack_public_path__ + "static/media/eqifi_logo.5634ceb3f3b2e86ce8ebcabfed8bbdfb.svg";
export { ForwardRef as ReactComponent };